import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TdspBaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TdspInsertionOrderService extends TdspBaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  get resource_url(): string {
    return `${this.activeBaseUrl}/insertion-order/`;
  }

  getIOChangeLogs(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/change-log`, "", params);
    return this.get(url);
  }

  pixelBulkEdit(data, params) {
    let url = this.buildUrl(
      `${this.resource_url}bulk-edit-pixels/`,
      "",
      params
    );
    return this.patch(url, data);
  }

  flightBulkEdit(data, params) {
    let url = this.buildUrl(
      `${this.resource_url}bulk-edit-flights/`,
      "",
      params
    );
    return this.patch(url, data);
  }

  getCommissionHistory(id: number, params: any = {}): Observable<any> {
    let url = this.buildUrl(`${this.resource_url}${id}/commission-history/`, "", params);
    return this.get(url);
  }
}
